/*
 *  I11PERCHARESReducer.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 22:04:58 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { I11PERCHARES_State } from '@batical/types/src'
import I11PERCHADISCHAReducer from '../Calculs/I11PERCHADISCHAReducer'

const I11PERCHARES: I11PERCHARES_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  accidents: [],
  contextCha: I11PERCHADISCHAReducer,
  saveDate: 0,
  in_accidents: 0.0,
  pdcUnitSelected_uuid: '6D91E213-CFEA-4A37-A3FF-5A3D10E60966',
  res_totalDzeta: 0.0,
  res_pdcFrottement: 0.0,
  res_pdfTotal: 0.0,
  mode: 'none',
  calcul_code: 'I11PERCHARES'
}

export default I11PERCHARES
